import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'
import { Field, reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { 
  Form,
  TextArea,
  Button,
  Confirm,
  Dropdown,
  Input } from  'semantic-ui-react'
import r from 'reactotron-react-js'

import { 
  Cont,} from './styled'
import {
  StdCard} from 'components'
import {approverPRAction} from 'ducks/purchaseRequisition'
import ChatModal from './ChatModal'
import FieldInput, { InputType as type } from 'components/SemanticForm'

const PRAction = (props) => {
  const {
    prDetail,
    setShowApprovalChat,
    showApprovalChat,
    approverAction,
    handleSubmit,
    approverPRAction,
    userSN
  } = props
  return (
    <StdCard title='Action for Approval' style={{width:'100%',marginTop:'1rem'}}>
      <Cont>
        <Form onSubmit={handleSubmit(()=>submitValidate(props.valueForm))}>
          <div style={{display:'flex',flexDirection:'column'}}>
            <div style={{display:'flex'}}>
              <Field 
                name='comment' 
                label='Your Comment' 
                type={type.textArea}
                containerStyle={{ marginRight: '0px' }}
                component={FieldInput} /> 
              {/* <Icon name='comments'size='big' circular inverted color='teal' link onClick={()=>setShowApprovalChat(!showApprovalChat)}/> */}
            </div>  
            <Field
              name='commentAttachments'
              label='Attachments'
              type={type.file}
              component={FieldInput}
              containerStyle={{ marginRight: 0 }}
            />
            <div style={{marginTop:'1rem'}}>
              {
                approverAction.map((item)=>{
                  return(
                    <Button type='submit' style={{ marginTop: '0.5rem' }} color={`${item.toLowerCase()==='reject'?'red':item.toLowerCase()==='revise'?'orange':'green'}`} onClick={()=>props.setSubmitActionName(item)}>{item}</Button>
                  )
                })
              }
            </div>
          </div>
          <ChatModal open={showApprovalChat} onCloseClick={()=>setShowApprovalChat(!showApprovalChat)}/>
          <Confirm
            size='mini'
            open={props.showConfirm}
            onCancel={()=>props.setShowConfirm(false)}
            onConfirm={()=>submitAction()}
          />  
        </Form>
      </Cont>
    </StdCard>
  )

  function submitValidate(values){
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100) // simulate server latency
    .then(() => {
      if(props.submitActionName.toLowerCase()!=='approve'&&props.submitActionName.toLowerCase()!=='submit'&&props.submitActionName.toLowerCase()!=='review'&&props.submitActionName.toLowerCase()!=='accept'){
        if(values.comment.trim().length===0){
          throw new SubmissionError({ comment: 'Required!'})
        }
      }
      props.setShowConfirm(true)
    })
  }

  function submitAction(){
    props.setShowConfirm(false)
    approverPRAction({
      prId:prDetail.data.id,
      SN:userSN,
      action:props.submitActionName,
      comment:props.valueForm.comment,
      history: props.history,
      commentAttachments:props.valueForm.commentAttachments
    })
  }

}

export const renderTextArea = ({ input, meta: { touched, error, warning } }) => {
  return (
    <div style={{width:'100%',display:'flex',flexDirection:'column'}}>
      <TextArea className='field-input' {...input} rows={3} />
      <div className='field-label'>
        {touched &&
          ((error && <span style={{color:'red'}}>{error}</span>) ||
            (warning && <span style={{color:'red'}}>{warning}</span>)
          )}
      </div>
    </div>
  )
}

export const renderDropdown = props => {
  const { fields,data, meta: { touched, error, warning } } = props
  return (
    <div>
      <Dropdown 
        selection
        value={props.input.value}
        fluid
        search
        onChange={(param,data) => {props.input.onChange(data.value)}}
        placeholder={props.label} 
        options={props.option}
      />
    </div>
  )
}

export const renderInput = props => {
  const {input,disabled,placeholder, meta: { touched, error, warning }} = props
  return (
    <div style={{width:'100%',display:'flex',flexDirection:'column'}}>
    <Input 
      {...input}
      disabled={disabled||false}
      placeholder={placeholder||""} />
      <div className='field-label'>
        {touched &&
          ((error && <span style={{color:'red'}}>{error}</span>) ||
            (warning && <span style={{color:'red'}}>{warning}</span>)
          )}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return ({
    initialValues: {
      comment:''
    },
    valueForm: getFormValues('formPRApprovalAction')(state),
    approverAction: state.pr.approverAction,
    prDetail: state.pr.prDetail,
    userSN: state.pr.userSN,
    user: state.authen.user
  })
}
const mapDispatchToProps = {
  approverPRAction
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('showApprovalChat','setShowApprovalChat',false),
  withState('submitActionName','setSubmitActionName',''),
  withState('showConfirm','setShowConfirm',false),
  connect((state, props) => ({
    history: props.history
  })),
  reduxForm({
    form: 'formPRApprovalAction',
    enableReinitialize: true,
  }),
  lifecycle({
    componentDidMount() {
     
    },
    componentWillReceiveProps(nextProp) {
      
    }
  })
)

export default enhance(PRAction)
